import React from 'react';

function SectionHeading({ eyebrow, children, light = false }) {
  return (
    <div className={`section-heading${light ? ' section-heading-light' : ''}`}>
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h2>{children}</h2>
      <span className="heading-mark" aria-hidden="true" />
    </div>
  );
}

export default SectionHeading;